import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import {
  AuthStore,
  BookingStore,
  BookingSubscriptionPackageOptions,
  RemoteConfigStore,
} from '@store';

@Component({
  selector: 'app-booking-overview',
  templateUrl: './booking-overview.component.html',
  styleUrls: ['./booking-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingOverviewComponent implements OnInit {
  BookingSubscriptionPackageOptions = BookingSubscriptionPackageOptions;
  constructor(
    public authStore: AuthStore,
    public remoteConfigStore: RemoteConfigStore,
    private bookingStore: BookingStore
  ) {}

  ngOnInit(): void {
    this.bookingStore.loadInstallations();
    this.bookingStore.getAllVitoguideSubscriptions();
  }
}
